import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { Briefcase } from 'lucide-react'

const features = [
  { name: 'Project Overview', description: 'High-level project summary and status' },
  { name: 'Task Board', description: 'Kanban board for project tasks' },
  { name: 'Team Members', description: 'View and manage project team' },
  { name: 'Files & Documents', description: 'Project-related documents and files' },
]

export default function ProjectDetailView() {
  return (
    <PlaceholderPage
      title="Project Details"
      description="View and manage individual projects"
      icon={Briefcase}
      features={features}
      accentColor="emerald"
    />
  )
}
